import React, { useState, useEffect } from 'react';
import Title from '../../components/title/Title';
import Button from '../../components/button/Button';
import './Home.css';

const PageTitle = (props) => {
    return(
        <div className='page-title'>
            <h2>{ props.children }</h2>
        </div>
    );
}

const Home = (props) => {

    const { estado } = props;
    
    /*const [ estado, setEstado ] = useState({
        empresa: {
            nit: '',
            razonSocial: '',
            nombreAlterno: ''
        },
        proveedor: {
            nit: '',
            razonSocial: '',
            tel: '',
            email: ''
        },
        loading: true,
        error: {}
    });*/

    useEffect(() => {
        /*setEstado(JSON.parse(sessionStorage.getItem('estado')));
        setEstado({
            ...estado,
            proveedor: JSON.parse(sessionStorage.getItem('proveedor'))
        });
        //setEstado(props.estado);*/

    }, []);

    const goToOldPortal = () => {
        window.open('http://181.49.46.230:9080', "_blank");
    }

    return(
        <div className='page-container'>
            <Title>Bienvenido al portal para proveedores</Title>
            <div className='page-body'>
                <div>
                    Navegue a través de las opciones de la izquierda.
                </div>
                <br />
                {/*
                <div className="home-info-container">
                    <div>Este nuevo portal esta en proceso de construcción, si no encuentra alguna información lo invitamos a dirigirse al portal antiguo dando click en el botón situado abajo o en la opción portal antiguo en el menu lateral.</div>
                    <div>recuerde que los datos de acceso (usuario y contraseña) son los que tenia cuando se registro con anterioridad en el portal antiguo y pueden variar.</div>
                    <br />
                    <Button type='button' onClick={goToOldPortal}>Ir al portal antiguo</Button>
                </div>
                */}
                <br />
                <div className="home-info-container">
                    <div>Estimado proveedor recuerde que tenemos atención personalizada en los siguientes horarios:</div>
                    <div className="home-info-item">Atención Telefónica: Lunes y viernes de 8:00 a.m. a 12:00 m y de 2:00 p.m. a 5:00 p.m.</div>
                    <div className="home-info-item">Presencial: Lunes de 2:00 p.m. a 5:00 p.m.</div>
                </div>
                <table className='info-table'>
                    <thead>
                        <tr>
                            <th colSpan='2'>Información del proveedor</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><div className='table-title'>N.I.T.:</div></td>
                            <td>{ estado.proveedor.nit }</td>
                        </tr>
                        <tr>
                            <td><div className='table-title'>Razón social:</div></td>
                            <td>{ estado.proveedor.razonSocial }</td>
                        </tr>
                        <tr>
                            <td><div className='table-title'>Celular:</div></td>
                            <td>{ estado.proveedor.tel }</td>
                        </tr>
                        <tr>
                            <td><div className='table-title'>Correo eléctronico:</div></td>
                            <td>{ estado.proveedor.email }</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default Home;